import React from "react";
import PropTypes from 'prop-types';
import {Allow} from "../../../components/authorization/Allow";
import {PtsPolicy, policyEvents} from "../../../components/authorization/policies/PtsPolicy";
import Button from "../../../components/common/buttons/Button";
import ButtonBar from "../../../components/common/buttons/ButtonBar";
import * as ButtonBarPositions from "../../../constants/ButtonBarPositions";
import * as ButtonTypes from "../../../constants/ButtonTypes";

export const PtsDeliverableSummaryButtons = ({
                                                 disableFields,
                                                 handleClickCancelEdit,
                                                 handleClickDelete,
                                                 handleClickSave,
                                                 isAdding,
                                                 validateForm
                                             }) => {
    const cancelLabel = disableFields ? `Close` : `Cancel`;
    return (
        <ButtonBar position={ButtonBarPositions.STICKY_BOTTOM} className={`implementationEditButtonContainer`}>
            {
                !disableFields &&
                <Button buttonType={ButtonTypes.SAVE} label={`Save`} name={`btnSave`}
                        onClick={(event) => handleClickSave(event, validateForm)} showLabel/>
            }

            <Button buttonType={ButtonTypes.CANCEL} label={cancelLabel} name={`btnCancel`}
                    onClick={handleClickCancelEdit} showLabel/>

            {
                !disableFields && !isAdding &&
                <Allow policy={PtsPolicy} policyEvent={policyEvents.IMPLEMENTATIONS.delete}>
                    <Button buttonType={ButtonTypes.DELETE} label={`Delete`} name={`btnDelete`}
                        onClick={handleClickDelete} showLabel />
                </Allow>
            }
        </ButtonBar>
    )
};

PtsDeliverableSummaryButtons.propTypes = {
    disableFields: PropTypes.bool.isRequired,
    handleClickCancelEdit: PropTypes.func.isRequired,
    handleClickDelete: PropTypes.func.isRequired,
    handleClickSave: PropTypes.func.isRequired,
    isAdding: PropTypes.bool.isRequired,
    validateForm: PropTypes.func.isRequired
};